<section [@routerTransition]>
    <div class="row">
        <div class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="input-group d-flex flex-column mr-2">
                <label for="dataInicio" class="mb-1">Data início</label>
                <div class="input-group">
                    <i class="input-group-text hgi hgi-stroke hgi-calendar-04"></i>
                    <input id="dataInicio" type="date" class="custom-date-input" name="dataInicio"
                        [(ngModel)]="dataInicio" (change)="refresh()" />
                </div>
            </div>

            <div class="input-group d-flex flex-column mr-2">
                <label for="dataFinal" class="mb-1">Data final</label>
                <div class="input-group">
                    <i class="input-group-text hgi hgi-stroke hgi-calendar-04"></i>
                    <input id="dataFinal" type="date" class="custom-date-input" name="dataFinal" [(ngModel)]="dataFim"
                        (change)="refresh()" />
                </div>
            </div>

        </div>
        <div *ngIf="tipoPrescricaoCid.length > 0" class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="d-flex flex-column select-container mr-2">
                <label for="cid" class="form-label">Cids</label>
                <select name="cid" id="cid" class="form-control" (change)="refresh()" [(ngModel)]="this.request.cidId">
                    <option disabled [value]="undefined">Selecione uma opção</option>
                    <option *ngFor="let tipo of tipoPrescricaoCid" [value]="tipo.id">{{tipo.nome}}</option>
                </select>
            </div>
        </div>
        <div *ngIf="tipoPrescricaoMedicamentoSigtap.length > 0"
            class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="d-flex flex-column select-container mr-2">
                <label for="medicamentoSigtap" class="form-label">Medicamentos Sigtap</label>
                <select name="medicamentoSigtap" id="medicamentoSigtap" class="form-control" (change)="refresh()"
                    [(ngModel)]="this.request.medicamentoSigtapId">
                    <option disabled [value]="undefined">Selecione uma opção</option>
                    <option *ngFor="let tipo of tipoPrescricaoMedicamentoSigtap" [value]="tipo.id">{{tipo.nome}}
                    </option>
                </select>
            </div>
        </div>
        <div *ngIf="tipoPrescricaoMedicamentoTiss.length > 0"
            class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="d-flex flex-column select-container mr-2">
                <label for="medicamentoTiss" class="form-label">Medicamentos Tiss</label>
                <select name="medicamentoTiss" id="medicamentoTiss" class="form-control" (change)="refresh()"
                    [(ngModel)]="this.request.medicamentoTissId">
                    <option disabled [value]="undefined">Selecione uma opção</option>
                    <option *ngFor="let tipo of tipoPrescricaoMedicamentoTiss" [value]="tipo.id">{{tipo.nome}}</option>
                </select>
            </div>
        </div>
        <div *ngIf="tipoPrescricaoProcedimentoSigtap.length > 0"
            class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="d-flex flex-column select-container mr-2">
                <label for="procedimentoSigtap" class="form-label">Procedimentos Sigtap</label>
                <select name="procedimentoSigtap" id="procedimentoSigtap" class="form-control" (change)="refresh()"
                    [(ngModel)]="this.request.procedimentoSigtapId">
                    <option disabled [value]="undefined">Selecione uma opção</option>
                    <option *ngFor="let tipo of tipoPrescricaoProcedimentoSigtap" [value]="tipo.id">{{tipo.nome}}
                    </option>
                </select>
            </div>
        </div>
        <div *ngIf="tipoPrescricaoProcedimentoTuss.length > 0"
            class="col-auto p-0 d-flex align-items-center filter-container">
            <div class="d-flex flex-column select-container mr-2">
                <label for="procedimentoTuss" class="form-label">Procedimentos Tuss</label>
                <select name="procedimentoTuss" id="procedimentoTuss" class="form-control" (change)="refresh()"
                    [(ngModel)]="this.request.procedimentoTussId">
                    <option disabled [value]="undefined">Selecione uma opção</option>
                    <option *ngFor="let tipo of tipoPrescricaoProcedimentoTuss" [value]="tipo.id">{{tipo.nome}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="row">
        <button class="btn btn-filtros" (click)="limparFiltros()">
            Limpar filtros
            <i class="hgi hgi-stroke hgi-delete-02 ml-1"></i>
        </button>
    </div>

    <app-paciente-monitorado [pacienteAtual]="pacienteAtual" [pacienteInicial]="pacienteInicial"
        [temDependentes]="dependentes.length > 0" (selecionarDependente)="selecionarDependentes()"
        (voltarPaciente)="voltarParaPacienteInicial()">
    </app-paciente-monitorado>

    <div class="table-container table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Paciente</th>
                    <th>Responsável</th>
                    <th>Nome do Arquivo</th>
                    <th>Cids</th>
                    <th>Procedimento Tuss</th>
                    <th>Procedimento Sigtap</th>
                    <th>Medicamento Tiss</th>
                    <th>Medicamento Sigtap</th>
                    <th>Data de Criação</th>
                    <th>Ação</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="
                let prescricao of prescricoes
                  | paginate
                    : {
                        id: 'server',
                        itemsPerPage: pageSize,
                        currentPage: pageNumber,
                        totalItems: totalItems
                      }
                ">
                    <td>{{prescricao.nomePaciente | showDashIfNull}}</td>
                    <td>{{prescricao.nomeResponsavel | showDashIfNull}}</td>
                    <td>{{prescricao.nomeArquivo | showDashIfNull}}</td>
                    <td>{{prescricao.cids | showDashIfNull}}</td>
                    <td>{{prescricao.procedimentoTuss | showDashIfNull}}</td>
                    <td>{{prescricao.procedimentoSigtap | showDashIfNull}}</td>
                    <td>{{prescricao.medicamentoTiss | showDashIfNull}}</td>
                    <td>{{prescricao.medicamentoSigtap | showDashIfNull}}</td>
                    <td>{{prescricao.creationTime | date: "dd/MM/yyyy"}}</td>
                    <td>
                        <button title="Baixar arquivo" type="button" class="btn icon icon-ligth-blue"
                            (click)="download(prescricao)">
                            <i class="hgi hgi-stroke hgi-download-05"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="float-sm-right m-auto">
                <abp-pagination-controls id="server" (pageChange)="getDataPage($event)">
                </abp-pagination-controls>
            </div>
        </div>
    </div>
</section>